<template>
    <div>
        <Loader />
        <header class="page-header">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2>Транзакции</h2>
                    </div>
                </div>
                <form @submit.prevent="getPayments">
                    <div class="row pb-3">

                        <div class="col-3">

                            <div class="trn-search-label">Фильтр</div>

                            <div class="row">

                                <div class="col-12">
                                    <div class="form-group">
                                        <app-datepicker-filter v-model="formData.date_range"></app-datepicker-filter>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <select class="form-control" v-model="formData.type_id">
                                            <option value="">-- Тип платежа --</option>
                                            <option v-for="(key, value) in types" :value="value">{{ key }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <select class="form-control" v-model="formData.status_id">
                                            <option value="">-- Все статусы --</option>
                                            <option v-for="(key, value) in statuses" :value="value" > {{ key }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <select class="form-control" v-model="formData.acquiring_id">
                                            <option value="">-- Платежная система --</option>
                                            <option v-for="item in acquirings" :value="item.id">{{ item.title }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <select v-model="formData.pagination_count" class="form-control w-25" @change="getPayments">
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <button class="btn btn-primary mr-2" type="submit"><i class="fa fa-search text-white mr-2"></i>Искать</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-3">
                            <div class="trn-search-label">Данные транзакции</div>
                            <div class="row row-small">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input type="text" v-model="formData.id" class="form-control" placeholder="Идентификатор транзакции">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input type="text" v-model="formData.reference" class="form-control" placeholder="Номер заказа">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input type="text" v-model="formData.bank_reference" class="form-control" placeholder="Референс транзакции">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input type="text" v-model="formData.amount" class="form-control" placeholder="Сумма транзакции">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" v-model="formData.is_test"> Тестовые платежи
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-4">

                            <div class="trn-search-label">Данные пользователя</div>
                            <div class="row row-small">
                                <div class="col-12">
                                    <div class="form-group">
                                        <input type="text" class="form-control" placeholder="Email пользователя" v-model="formData.user_email">
                                    </div>
                                </div>

                                <div class="col-8">
                                    <div class="form-group">
                                        <input type="text" class="form-control" placeholder="Номер телефона пользователя" v-model="formData.user_phone">
                                    </div>
                                </div>
                                <div class="col-8">
                                    <div class="form-group">
                                       <input type="text" class="form-control" placeholder="ID пользователя" v-model="formData.user_id">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </header>
        <div class="container mt-3">

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="alert alert-dark" v-if="payments.length === 0">Данные не найдены</div>
                            <div v-else>
                                <h5>Сумма: {{ sumPayments }}</h5>
                                <h5>Количество: {{ countPayments }}</h5>
                            </div>
                            <table class="table table-hover table-sm" v-if="payments.length > 0">
                                <thead>
                                <tr>
                                    <th style="width: 10%">ID</th>
                                    <th style="width: 10%">Номер заказа</th>
                                    <th style="width: 5%">ID пользователя</th>
                                    <th style="width: 10%;">Сумма</th>
                                    <th style="width: 5%">Тип</th>
                                    <th style="width: 10%">Телефон</th>
                                    <th style="width: 15%">Email</th>
                                    <th style="width: 20%">Дата</th>
                                    <th style="width: 10%">Статус</th>
                                    <th style="width: 5%"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="payment in payments" :class="payment.status === 1 ? 'table-success' : ''">
                                    <td>{{ payment.id }}</td>
                                    <td>{{ payment.reference_id }}</td>
                                    <td>{{ payment.user_id }}</td>
                                    <td>{{ payment.amount }}</td>
                                    <td>{{ types[payment.type] }}</td>
                                    <td>{{ payment.user_phone }}</td>
                                    <td>{{ payment.user_email }}</td>
                                    <td>{{ payment.created_at }}</td>
                                    <td>{{ statuses[payment.status] }}</td>
                                    <td><a :href="'/admin/transaction/' + payment.id"><i class="fa fa-search"></i> </a></td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="text-center" v-if="showLoadButton">
                                <button class="btn btn-primary" @click="loadMorePayments" type="button">Загрузить еще...</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Loader from "./Loader";

    export default {
        name: "Transactions",
        components: { Loader },
        data() {
            return {
                formData: {
                    id: '',
                    reference: '',
                    amount: '',
                    bank_reference: '',
                    acquiring_id: '',
                    type_id: '',
                    status_id: '',
                    date_range: '',
                    userPhone: '',
                    userEmail: '',
                    userId: '',
                    is_test: false,
                    pagination_count: 20,
                    page: 1
                },
                types: [],
                payments: [],
                statuses: [],
                acquirings: [
                    { id: 1, title: 'Халык Банк' },
                    { id: 2, title: 'Альфа Банк' }
                ],
                showLoadButton: true,
                countPayments: 0
            }
        },
        created() {
            this.getStatus();
            this.getType();
            this.getPayments();
        },
        methods: {
            getStatus() {
              axios.get('/admin/ajax/statuses')
                .then(response => {
                    this.statuses = response.data;
                })
            },
            getType() {
                axios.get('/admin/ajax/types')
                    .then(response => {
                        this.types = response.data;
                    })
            },
            getPayments() {
                if (this.formData.date_range) {
                    this.formData.date_range.start = this.formData.date_range.start.replace(/'/g, '');
                    this.formData.date_range.end = this.formData.date_range.end.replace(/'/g, '');
                }
                this.formData.page = 1;
                this.$store.commit('setLoading');
                axios.get('/admin/ajax/transactions', {params: this.formData})
                    .then(response => {
                        response = response.data;
                        this.payments = response.data.data;
                        this.showLoadButton = response.data.current_page < response.data.last_page;
                        this.countPayments = response.data.total;
                        this.sumPayments = response.data.sum;
                    })
                    .catch(error => {})
                    .then(() => {
                        this.$store.commit('unsetLoading');
                    });
            },
            loadMorePayments() {
                this.formData.page += 1;
                this.$store.commit('setLoading');
                axios.get('/admin/ajax/transactions', {params: this.formData})
                    .then(response => {
                        response = response.data;
                        this.payments = this.payments.concat(response.data.data);
                        this.showLoadButton = response.data.current_page < response.data.last_page;
                        this.countPayments = response.data.total
                    })
                    .catch(error => {})
                    .then(() => {
                        this.$store.commit('unsetLoading');
                    });
            },
        }
    }
</script>

<style scoped>
    .form-control.w-25 {
        display: inline-block;
    }
    .btn.btn-primary.mr-2 {
        margin-bottom: 1px;
        margin-left: 10px;
    }
</style>
